import React from "react"
import IntroSection from "../components/IntroSection";
import ScopingSolution from "../components/ScopingSolution";
import BlueSectionDivider from "../components/BlueSectionDivider";
import SoftwareProcess from "../components/SoftwareProcess";
import CustomerTestimonials from "../components/CustomerTestimonials";
import SoftwareBenefits from "../components/SoftwareBenefits";
import SoftwareAwards from "../components/SoftwareAwards";
import CountriesSection from "../components/CountriesSection";
import SoftwareReimagine from "../components/SoftwareReimagine";
import SoftwareProjects from "../components/SoftwareProjects";
import TeamSection from "../components/TeamSection";
import WhyUsSection from "../components/WhyUsSection";
import WorkingModelSection from "../components/WorkingModelSection";
import TechStackSection from "../components/TechStackSection";
import SoftwareFaq from "../components/SoftwareFaq";
import SoftwareResources from "../components/SoftwareResources";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";


const SoftwareDevelopment = () => {

    return(
        <div>
            <IntroSection title = "CUSTOM SOFTWARE DEVELOPMENT SOLUTIONS" paragraph = "Build faster, better, and larger-scale software, from SaaS and Web Apps to Enterprise Software." backgroundImage="/images/sd-bg.webp"/>
            <ScopingSolution para1 = "We specialize in delivering customized solutions in SaaS software, API development, custom software, and mobile apps, enterprise software and others." para2 = "Our uniquely trained consultants will guide you through our Agile Development Process, ensuring that every solution is crafted to meet the unique demands and goals of your company. By leveraging our commitment to rapid, high-quality, and scalable solutions, we help you create powerful software that drives your growth and strengthens your competitive edge."/>
            <BlueSectionDivider/>
            <SoftwareProcess/>
            
            <SoftwareBenefits/>
            
            <CountriesSection/>
            <BlueSectionDivider/>
            <SoftwareReimagine/>
            <SoftwareProjects/>
            <TeamSection/>
            <WhyUsSection/>
            <WorkingModelSection/>
            <TechStackSection/>
            <SoftwareFaq/>
            <BlueSectionDivider/>
          
            <ContactSection backgroundColor="#057af0ff"/>
            <Footer/>

        </div>
    )
}
export default SoftwareDevelopment;